export const customerTabs = {
  customerDetails: {
    key: 'customer-details',
    label: 'Customer',
  },
  vehicleDetails: {
    key: 'vehicle-details',
    label: 'Vehicle',
  },
  orders: {
    key: 'orders',
    label: 'Orders',
  },
  audit: {
    key: 'audit-details',
    label: 'Audit',
  },
};
